import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container:{
        backgroundColor: theme.palette.common.white,
        width: '100%',
        height: '100%',
        position: 'relative'
    },
    title:{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '18px',
        background: "linear-gradient(135deg, #26a69a 0%, #00897b 100%)",
        color: theme.palette.common.white,
        padding: "10px 8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        borderRadius: "0 0 8px 8px",
    },
    title_options: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    item_row_container: {
        display: "grid",
        rowGap: 8,
        padding: 8
    },
    
    item_row: {
        display: "grid",
        gridTemplateColumns: "200px 160px auto 60px",
        padding: 8,
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: 4,
        backgroundColor: theme.palette.grey[100],
        columnGap: 8,
        cursor: "pointer",
        "&:hover":{
            backgroundColor: theme.palette.grey[200],
        }
    },
    item_sales_container: {
        display: "grid",
        gridTemplateColumns: 'repeat( auto-fit, minmax(130px, 1fr))',
        columnGap: 8
    },
    no_content_container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '14px',
        height: '100%',
        color: theme.palette.grey[400],
        textAlign: 'center',
        cursor: 'pointer',
        "& svg": {
            fontSize: '50px'
        }
    },
    loading_container: {
        minHeight: '80px',
    },
    seller_row_container:{
        display: "flex",
        flexDirection:"column"
    },
    chips_container: {
        display: 'flex',
        gap: 8,
        color: "#FFF",
    },
    chip: {
        backgroundColor: "rgba(255, 255, 255, 0.15)",
        color: "#fff",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        backdropFilter: "blur(10px)",
        transition: "all 0.2s ease-in-out",
        "& .MuiChip-icon": {
            color: "#fff",
        },
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.25)",
        },
    },
}));

export {useStyles}